import type { ChatTurnProps } from "../../types/chat";

// Nothing to ask once KYC is rejected: the failed screen opens straight away.
export const getKycFailedScreen = (props: ChatTurnProps): string =>
  props.step.screen.entry(props.facts);
